import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';
import { fetchAllTypeaheadDiskSize } from '../../../actions';

class DiskSizeTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadDiskSize: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadDiskSize(DiskSizeTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        let options = [];
        if (this.props.suggestions.length) {
            options = this.props.suggestions.map(disk => ({
                label: disk.name, value: disk.id
            }));
        }

        return (
            <MultiTypeahead
                options={options || []}
                disabled={this.props.disabled}
                required={false}
                isClearable={this.props.isClearable}
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId={this.props.name}
                animatedPlaceholder={this.props.animatedPlaceholder}
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === DiskSizeTypeahead.name
            ? typeahead.list
            : DiskSizeTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadDiskSize,
})(DiskSizeTypeahead);
